import createTransporterOrder from './addOrderToTransporter/createTransporterOrder';
import { newTransporterOrderRequest } from '../../requests';
import { throwTranslatableError } from '@/core';

export default async function addOrderToTransporter({ dispatch },{
	order,
	vendor,
	etd,
	eta,
	despatchOption,
	deliveryOption,
	customDespatchParty,
	customDeliveryParty,
	serviceCode,
	sendEmail,
	freeText,
}) {
	if (!order || !vendor || !etd) {
		throw new Error('failedToAddOrderToTransporter');
	}

	if (sendEmail && !vendor.email) {
		throw new Error('missingEmailAddress');
	}

	let addedOrders = [];
	addedOrders.push(createTransporterOrder(order, vendor, etd, eta, despatchOption, deliveryOption, customDespatchParty, customDeliveryParty, serviceCode));

	if (addedOrders.length > 0) {
		try {
			await newTransporterOrderRequest({ vendor, orders: addedOrders, etd, sendEmail, freeText });
			dispatch('autoRefreshOrder');
		} catch (e) {
			throwTranslatableError(e, 'failedToAddOrderToTransporter');
		}
	}
}